import React from 'react';
import styles from './styles.module.scss';

function Header({ ...others }) {
  return <div className={styles.header} {...others} />;
}

export default Header;
